/* @flow */
import React from 'react';
import { graphql, createRefetchContainer } from 'react-relay';
import { Card, CardTitle, CardText } from 'material-ui/Card';

import JobRequestHeader from './components/JobRequestHeader';
import AcceptedJobOffer from './components/AcceptedJobOffer';
import JobSession from './components/JobSessions';

import type { Job_job } from './__generated__/Job_job.graphql';

import enhancer from '../enhancer';

const styles = {
  header: {
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  container: {
    width: '100%',
  },
  card: {
    padding: 10,
  },
};

type Props = {
  job: Job_job,
};

const Job = ({ job }: Props) => {
  const { acceptedJobOffer: { jobRequest } } = job;

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <Card>
          <CardTitle
            title="Job Request"
            subtitle={jobRequest.student.fullname}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            {<JobRequestHeader request={jobRequest} />}
          </CardText>
        </Card>
      </div>

      <div style={styles.card}>
        <Card>
          <CardTitle
            title="Accepted Offer"
            subtitle={job.acceptedJobOffer.tutor.fullname}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            <AcceptedJobOffer offer={job.acceptedJobOffer} />
          </CardText>
        </Card>
      </div>

      <div style={styles.card}>
        <Card>
          <CardTitle title="Sessions" actAsExpander showExpandableButton />
          <CardText expandable>
            <JobSession job={job} />
          </CardText>
        </Card>
      </div>
    </div>
  );
};

const query = graphql`
  query JobAdminQuery($nodeId: ID!) {
    job: node(id: $nodeId) {
      ...Job_job
    }
  }
`;

export default enhancer(Job, {
  relay: {
    query,
    create: () =>
      createRefetchContainer(
        Job,
        {
          job: graphql`
            fragment Job_job on Job {
              id
              ...JobSessions_job
              status
              paymentTutor
              paymentStudent
              paymentInternal
              paymentExternal
              acceptedJobOffer {
                tutor {
                  fullname
                }
                ...AcceptedJobOffer_offer
                jobRequest {
                  student {
                    fullname
                  }
                  ...JobRequestHeader_request
                }
              }
            }
          `,
        },
        query
      ),
  },
});



// WEBPACK FOOTER //
// ./src/modules/job/Job.js